import {
  LayoutDashboard,
  Users,
  UserCog,
  HeartHandshake,
  CalendarDays,
  ClipboardList,
  Hourglass,
  FileText,
  Wallet,
  CreditCard,
  ShieldCheck,
  BarChart3,
  Settings,
  UserPlus,
  Package,
  History,
  Trash2,
} from "lucide-react";
import Horse from "@/components/icons/Horse";

export const ROLES = {
  ADMIN: "admin",
  RECEPCIONISTA: "recepcionista",
  TERAPEUTA: "terapeuta",
  FINANCEIRO: "financeiro",
};

export const ROLE_LABELS = {
  admin: "Administrador",
  recepcionista: "Recepção",
  terapeuta: "Terapeuta",
  financeiro: "Financeiro",
};

// RBAC refinado:
// Admin: tudo
// Recepção: cadastro básico, agenda, reagendamento, baixa de pagamentos, lista de espera
//   → sem financeiro completo, sem ficha clínica
// Terapeuta: praticantes (nome/responsável/ficha), evoluções, agenda
//   → sem financeiro, sem cadastro completo
// Financeiro: financeiro completo, cadastro básico e agenda para visualização
//   → sem ficha clínica

export const NAV_SECTIONS = [
  {
    label: "Principal",
    items: [
      { to: "/dashboard", label: "Início", icon: LayoutDashboard, roles: ["admin", "recepcionista", "terapeuta", "financeiro"] },
      { to: "/agenda", label: "Agenda", icon: CalendarDays, roles: ["admin", "recepcionista", "terapeuta", "financeiro"] },
    ],
  },
  {
    label: "Cadastros",
    items: [
      { to: "/praticantes", label: "Praticantes", icon: HeartHandshake, roles: ["admin", "recepcionista", "terapeuta", "financeiro"] },
      { to: "/cavalos", label: "Cavalos", icon: Horse, roles: ["admin"] },
      { to: "/convenios", label: "Convênios", icon: ShieldCheck, roles: ["admin", "financeiro"] },
    ],
  },
  {
    label: "Clínico",
    items: [
      { to: "/evolucoes", label: "Evolução Clínica", icon: ClipboardList, roles: ["admin", "terapeuta"] },
      { to: "/lista-espera", label: "Lista de Espera", icon: Hourglass, roles: ["admin", "recepcionista"] },
      { to: "/documentos", label: "Documentos", icon: FileText, roles: ["admin", "recepcionista"] },
    ],
  },
  {
    label: "Operacional",
    items: [
      { to: "/estoque", label: "Estoque", icon: Package, roles: ["admin"] },
    ],
  },
  {
    label: "Financeiro",
    items: [
      { to: "/financeiro", label: "Controle Financeiro", icon: Wallet, roles: ["admin", "financeiro"] },
      { to: "/funcionarios", label: "Funcionários", icon: UserCog, roles: ["admin", "financeiro"] },
      { to: "/pagamentos", label: "Pagamentos", icon: CreditCard, roles: ["admin", "financeiro", "recepcionista"] },
      { to: "/relatorios", label: "Relatórios", icon: BarChart3, roles: ["admin", "financeiro"] },
    ],
  },
  {
    label: "Administração",
    items: [
      { to: "/usuarios", label: "Usuários", icon: UserPlus, roles: ["admin"] },
      { to: "/auditoria", label: "Auditoria", icon: History, roles: ["admin"] },
      { to: "/lixeira", label: "Lixeira", icon: Trash2, roles: ["admin"] },
      { to: "/configuracoes", label: "Configurações", icon: Settings, roles: ["admin"] },
    ],
  },
];

export function filterNavByRole(role) {
  return NAV_SECTIONS.map((section) => ({
    ...section,
    items: section.items.filter((item) => item.roles.includes(role)),
  })).filter((section) => section.items.length > 0);
}
